import React, { useState, Fragment, useEffect } from 'react';
import DataTable from 'react-data-table-component'
// import Breadcrumb from '../common/breadcrumb';
import CountUp from 'react-countup';
import { toast } from 'react-toastify';
import API from '../../services/API';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { LineChart, Cell, LabelList, BarChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import Skeleton from 'react-loading-skeleton';
import { Link } from "react-router-dom";
import 'react-loading-skeleton/dist/skeleton.css';
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import 'react-circular-progressbar/dist/styles.css';
import "./Homepage.css"


const Homepage = props => {
    const formColorMap = [
        '#10B981', // green
        '#3B82F6', // blue
        '#F59E0B', // yellow
        '#EC4899', // pink
        '#8B5CF6', // purple
        '#EF4444', // red
        '#14B8A6', // teal
    ];
    const glowingIcon = L.divIcon({
        className: "", // leave blank so only our HTML applies
        html: `<div class="glow-circle"></div>`,
        iconSize: [70, 70],   // overall container size
        iconAnchor: [0, 0], // anchor in the center
    });
    const FitBounds = ({ clusters }) => {
        const map = useMap();

        useEffect(() => {
            if (clusters.length > 0) {
                const bounds = L.latLngBounds(
                    clusters.map(c => [c.latitude, c.longitude])
                );
                map.fitBounds(bounds, { padding: [50, 50] }); // add padding so points aren’t at edges
            }
        }, [clusters, map]);

        return null;
    };

    const getFormColor = (index) => {
        return formColorMap[index % formColorMap.length]; // loop if more forms than colors
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const [attendanceRate, setAttendanceRate] = useState({ attendance_rate: 0 });
    const [attendanceByForm, setAttendanceByForm] = useState([]);
    const [monthlyData, setMonthlyData] = useState({});
    const [trendRows, setTrendRows] = useState([]);
    const [dailyAbsences, setDailyAbsences] = useState([]);
    const [progressiveAbsences, setProgressiveAbsences] = useState([]);
    const [granularity] = useState("monthly");
    const [trendByForm, setTrendByForm] = useState(null);
    const [selectedClassId, setSelectedClassId] = useState('all');

    const currentMonth = new Date().toISOString().slice(0, 7);
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);
    const [classMonthlyData, setClassMonthlyData] = useState({});
    const [loadingTrendByForm, setLoadingTrendByForm] = useState(true);

    const [loadingMonthly, setLoadingMonthly] = useState(false);
    const [locationClusters, setLocationClusters] = useState([]);
    const [loadingClusters, setLoadingClusters] = useState(false);
    const [selectedClusterDate, setSelectedClusterDate] = useState(
        new Date().toISOString().slice(0, 10) // default today
    );
    const [classSummary, setClassSummary] = useState(null);
    const [loadingClassSummary, setLoadingClassSummary] = useState(false);

    const [fullScreen, setFullScreen] = useState(false);

    const [state, setState] = useState({
        // total_amount: 0,
        // average_amount: 0,
        totalStudent: 0
    })
    const [unrecorded, setUnrecorded] = useState(0);
    const [claimParents, setClaimedParents] = useState(0);

    const [schoolMood, setSchoolMood] = useState(null);
    const [loadingMood, setLoadingMood] = useState(false);
    const [moodPeriod, setMoodPeriod] = useState("weekly"); // weekly | monthly

    const [weeklyData, setWeeklyData] = useState({});
    const [selectedWeek, setSelectedWeek] = useState(() => {
        const now = new Date();
        const year = now.getFullYear();
        const week = Math.ceil(
            ((now - new Date(year, 0, 1)) / 86400000 + new Date(year, 0, 1).getDay() + 1) / 7
        );
        return `${year}-W${String(week).padStart(2, "0")}`;
    });
    const [classViewMode, setClassViewMode] = useState("month");
    const [showHeatmap, setShowHeatmap] = useState(true);
    // "month" | "week_by_month"
    const [zoom, setZoom] = useState(1); // 1 = 100%, 0.8 = 80%, etc.
    const [lastMood, setLastMood] = useState(null);
    const [customMonthlyMatrix, setCustomMonthlyMatrix] = useState(null);
    const [loadingCustomMonthlyMatrix, setLoadingCustomMonthlyMatrix] = useState(false);
    const [showCustomHeatmap, setShowCustomHeatmap] = useState(true);
    const [customMatrixViewMode, setCustomMatrixViewMode] = useState("slot"); // "slot" | "date"

    const fetchCustomMonthlyClassMatrix = async (month, viewMode = customMatrixViewMode) => {
        const headers = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            token: localStorage.getItem('token'),
        };

        setLoadingCustomMonthlyMatrix(true);

        try {
            const res = await API.get('/customAttendance/events/monthlyClassMatrix', {
                headers,
                params: {
                    month,
                    view_mode: viewMode,
                },
            });

            if (res.data.response_code === 1000) {
                setCustomMonthlyMatrix(res.data.data || null);
            } else {
                toast.error(res.data.message || 'Failed to load custom attendance matrix');
                setCustomMonthlyMatrix(null);
            }
        } catch (err) {
            toast.error(err?.message || 'Error fetching custom attendance matrix');
            setCustomMonthlyMatrix(null);
        } finally {
            setLoadingCustomMonthlyMatrix(false);
        }
    };
    useEffect(() => {
        fetchCustomMonthlyClassMatrix(selectedMonth, customMatrixViewMode);
    }, [selectedMonth, customMatrixViewMode]);
    useEffect(() => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token')
        };

        setLoadingClusters(true);
        API.get('/analytics/attendance/locationClusters', {
            headers,
            params: { radius: 30, is_portal: true, date: selectedClusterDate }
        })
            .then(response => {
                if (response.data.response_code === 1000) {
                    setLocationClusters(response.data.data || []);
                } else {
                    toast.error(response.data.message || "Failed to fetch clusters");
                    setLocationClusters([]);
                }
            })
            .catch(err => {
                toast.error(err.message || "Cluster API failed");
                setLocationClusters([]);
            })
            .finally(() => setLoadingClusters(false));
    }, [selectedClusterDate]);
    useEffect(() => {
        const fetchClassSummary = async () => {
            const headers = {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'token': localStorage.getItem('token'),
            };

            const selectedDate = `${selectedMonth}-01`; // use month start

            setLoadingClassSummary(true);
            try {
                const res = await API.post(
                    '/attendance/attendanceSummaryByClassView',
                    {
                        is_portal: true,
                        filter_type: classViewMode,
                        date: selectedDate,
                    },
                    { headers }
                );

                if (res.data.response_code === 1000) {
                    setClassSummary(res.data.data);
                } else {
                    toast.error(res.data.message || 'Failed to load class summary');
                    setClassSummary(null);
                }
            } catch (err) {
                toast.error(err.message || 'Error fetching class summary');
                setClassSummary(null);
            } finally {
                setLoadingClassSummary(false);
            }
        };

        fetchClassSummary();
    }, [selectedMonth, classViewMode]);
    useEffect(() => {
        let isMounted = true; // Prevents state updates on unmounted components or stale requests
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token')
        };

        setLoadingMood(true);

        // Calculate last month safely
        const [y, m] = selectedMonth.split("-").map(Number);
        const lastMonthDate = new Date(y, m - 1, 1); // Get first of current month
        lastMonthDate.setMonth(lastMonthDate.getMonth() - 1); // Roll back exactly one month
        const lastMonthStr = lastMonthDate.toISOString().slice(0, 7);

        const fetchCurrent = API.get('/attendance/attendanceMoodSummary', {
            headers,
            params: {
                is_portal: true,
                period: moodPeriod === "monthly" ? "month" : "week",
                month: selectedMonth
            }
        });

        const fetchLast = API.get('/attendance/attendanceMoodSummary', {
            headers,
            params: { is_portal: true, period: "month", month: lastMonthStr }
        });

        Promise.all([fetchCurrent, fetchLast])
            .then(([currentRes, lastRes]) => {
                if (!isMounted) return; // Exit if the user changed the month again already

                if (currentRes.data.response_code === 1000) {
                    setSchoolMood(currentRes.data.data);
                } else {
                    setSchoolMood(null);
                }

                if (lastRes.data.response_code === 1000) {
                    setLastMood(lastRes.data.data);
                } else {
                    setLastMood(null);
                }
            })
            .catch(err => console.error("Mood API Error:", err))
            .finally(() => {
                if (isMounted) setLoadingMood(false);
            });

        return () => { isMounted = false; }; // Cleanup function
    }, [selectedMonth, moodPeriod]);
    const [classes, setClass] = useState([]);
    const [columns] = useState([
        {
            name: "Class Name",
            sortable: true,
            center: true,
            grow: 2,
            cell: (row) => (
                <Link
                    to={`/class-details/${row.class_id ?? row.id}`}
                    style={{ color: "#0d6efd", fontWeight: 600, textDecoration: "none" }}
                >
                    {row.class_name}
                </Link>
            )
        },
        {
            name: "Total Students",
            selector: (row) => row.total_students, // Adjust field name to match your backend data
            sortable: true,
            center: true,
        },
        {
            name: "Checked In",
            selector: (row) => row.total_checked_in, // Adjust field name to match your backend data
            sortable: true,
            center: true,
        },
        {
            name: "Total MC",
            selector: (row) => row.total_mc,
            sortable: true,
            center: true,
        },
        {
            name: "Attendance Rate (%)",
            selector: (row) => row.attendance_rate?.toFixed(2), // Ensure 2 decimal points
            sortable: true,
            center: true,
        },
    ]);
    const fetchClassMonthlyAttendance = async ({ classId, month } = {}) => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token'),
        };

        if (!classId || classId === "all" || !month) {
            setClassMonthlyData({});
            return;
        }
        try {
            setLoadingMonthly(true);
            const res = await API.get('/analytics/attendance/monthlyAverage', {
                headers,
                params: { is_portal: true, class_id: classId, month }
            });

            if (res.data.response_code === 1000) {
                setClassMonthlyData(res.data.data || {});
            } else {
                toast.error(res.data.message || 'Failed to fetch class monthly attendance', { autoClose: 5000 });
                setClassMonthlyData({});
            }
        } catch (err) {
            toast.error(err?.message || 'Failed to fetch class monthly attendance', { autoClose: 5000 });
            setClassMonthlyData({});
        } finally {
            setLoadingMonthly(false);
        }
    };

    useEffect(() => {
        if (classes.length > 0) {
            const defaultClassId = classes[0]?.class_id ?? classes[0]?.id;
            setSelectedClassId(defaultClassId);
            fetchClassMonthlyAttendance({ classId: defaultClassId, month: selectedMonth });
        }
    }, [classes]);

    useEffect(() => {
        fetchClassMonthlyAttendance({ classId: selectedClassId, month: selectedMonth });
    }, [selectedClassId, selectedMonth]);

    useEffect(() => {
        // const first_time_login = localStorage.getItem('first_time_login')
        // if (first_time_login==1) {
        var headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token')
        }
        API.get('/portal/totalStudent', { headers }).then(response => {
            if (response.data.response_code == 1000) {
                setState(response.data.data)
                //history.push(`/dashboard`);
            } else if (response.data.response_code == 2000) {
                toast.error(`${response.data.message}`, { autoClose: 5000 })
            } else {
                toast.error(`${response.data.message}`, { autoClose: 5000 })
            }
        })
        API.get('/portal/totalUnrecordedStudent', { headers }).then(response => {
            if (response.data.response_code == 1000) {
                setUnrecorded(response.data.data.totalStudent)
                //history.push(`/dashboard`);
            } else if (response.data.response_code == 2000) {
                toast.error(`${response.data.message}`, { autoClose: 5000 })
            } else {
                toast.error(`${response.data.message}`, { autoClose: 5000 })
            }
        })
        API.get('/portal/totalParentsClaimed', { headers }).then(response => {
            if (response.data.response_code == 1000) {
                setClaimedParents(response.data.data.totalStudent)
                //history.push(`/dashboard`);
            } else if (response.data.response_code == 2000) {
                toast.error(`${response.data.message}`, { autoClose: 5000 })
            } else {
                toast.error(`${response.data.message}`, { autoClose: 5000 })
            }
        })
        API.get('/portal/totalStudentClass', { headers }).then(response => {
            if (response.data.response_code == 1000) {
                const fetchedClasses = response.data.data || [];
                setClass(fetchedClasses);

                if (fetchedClasses.length > 0) {
                    setSelectedClassId(fetchedClasses[0].class_id ?? fetchedClasses[0].id);
                }
            } else if (response.data.response_code == 2000) {
                toast.error(`${response.data.message}`, { autoClose: 5000 })
            } else {
                toast.error(`${response.data.message}`, { autoClose: 5000 })
            }
        })
        API.post('/portal/attendanceRateByForm', {}, { headers }).then(response => {
            if (response.data.code === 1000) {
                setAttendanceByForm(response.data.data);
            } else {
                toast.error(`${response.data.message}`, { autoClose: 5000 });
            }
        });
        API.post('/portal/todayAttendanceRate', {}, { headers }).then(response => {
            if (response.data.code === 1000) {
                setAttendanceRate(response.data.data);
            } else {
                toast.error(`${response.data.message}`, { autoClose: 5000 });
            }
        });
        API.get('/analytics/attendance/monthlyAverage', { headers, params: { is_portal: true, month: selectedMonth } }).then(response => {
            if (response.data.response_code === 1000) {
                setMonthlyData(response.data.data || {});
            } else {
                toast.error(response.data.message || "Failed to fetch trend", { autoClose: 5000 });
            }
        });
        API.get('/analytics/attendance/weeklyAverage', {
            headers,
            params: {
                is_portal: true,
                week: selectedWeek,
            }
        }).then(response => {
            if (response.data.response_code === 1000) {
                setWeeklyData(response.data.data || {});
            } else {
                toast.error(response.data.message || "Failed to fetch weekly average", { autoClose: 5000 });
            }
        });

        API.get('/analytics/attendance/trend', { headers, params: { is_portal: true, month: selectedMonth } })
            .then(response => {
                if (response.data.response_code === 1000) {
                    setTrendRows(response.data.data.trendRows || []);
                    setDailyAbsences(response.data.data.dailyAbsences || []);
                    setProgressiveAbsences(response.data.data.progressiveAbsences || []);
                } else {
                    toast.error(response.data.message || "Failed to fetch attendance trend", { autoClose: 5000 });
                }
            });
        API.get('/analytics/attendance/trendByForm', { headers, params: { is_portal: true, granularity } })
            .then(response => {
                if (response.data.response_code === 1000) {
                    setTrendByForm(response.data.data || {});
                } else {
                    toast.error(response.data.message || "Failed to fetch trend by form", { autoClose: 5000 });
                }
            });

    }, [selectedMonth]);

    useEffect(() => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'token': localStorage.getItem('token')
        };

        setLoadingTrendByForm(true);

        API.get('/analytics/attendance/trendByForm', {
            headers,
            params: {
                is_portal: true,
                granularity,
                month: selectedMonth,
            }
        })
            .then(response => {
                if (response.data.response_code === 1000) {
                    const data = response.data.data;

                    if (granularity === "monthly") {
                        setTrendByForm(Array.isArray(data) ? data : []);
                    } else {
                        setTrendByForm(
                            typeof data === "object" && !Array.isArray(data)
                                ? data
                                : {}
                        );
                    }
                } else {
                    toast.error(response.data.message || "Failed to fetch trend by form", {
                        autoClose: 5000,
                    });
                    setTrendByForm([]);
                }
            })
            .catch((err) => {
                toast.error(err?.message || "Failed to fetch trend by form", {
                    autoClose: 5000,
                });
                setTrendByForm([]);
            })
            .finally(() => setLoadingTrendByForm(false));
    }, [granularity, selectedMonth]);

    const totalStudentsLocation = locationClusters.reduce((s, c) => s + c.count, 0);
    const getHeatmapColor = (percent) => {
        if (percent === null || percent === undefined) return "transparent";
        if (percent >= 90) return "#dcfce7";   // strong green
        if (percent >= 80) return "#bbf7d0";   // green
        if (percent >= 60) return "#fef9c3";   // yellow
        if (percent >= 50) return "#fed7aa";   // orange
        return "#fecaca";                     // red
    };
    const getCustomMatrixCellColor = (percent) => {
        if (percent === null || percent === undefined) return 'transparent';

        const safePercent = Number(percent || 0);

        if (safePercent >= 90) return '#dcfce7';
        if (safePercent >= 75) return '#bbf7d0';
        if (safePercent >= 50) return '#fef9c3';
        if (safePercent > 0) return '#fed7aa';

        return '#f8fafc';
    };

    return (
        <Fragment>
            <div className="mysp-dashboard">
                {/* HERO */}
                <div className="mysp-hero-card">
                    <div>
                        <div className="mysp-kicker">MYSP.AI SCHOOL COMMAND CENTRE</div>
                        <h1>Attendance Intelligence Dashboard</h1>
                        <p>
                            Monitor attendance, face registration, parent connectivity, student mood,
                            class trends, location clusters and monthly attendance risk from one view.
                        </p>
                    </div>

                    <div className="mysp-hero-controls">
                        <label>Reporting Month</label>
                        <input
                            type="month"
                            className="form-control"
                            value={selectedMonth}
                            onChange={(e) => setSelectedMonth(e.target.value)}
                        />
                    </div>
                </div>

                {/* KPI GRID */}
                <div className="row g-4">
                    <div className="col-xl-3 col-md-6">
                        <DashboardCard
                            label="Today Attendance"
                            tone="red"
                            value={
                                loadingMonthly ? (
                                    <Skeleton width={120} height={36} />
                                ) : (
                                    <>
                                        <CountUp end={attendanceRate.attendance_count || 0} separator="," />
                                        <span>
                                            ({Number(attendanceRate.attendance_percentage || 0).toFixed(0)}%)
                                        </span>
                                    </>
                                )
                            }
                            description="Students checked in today"
                        />
                    </div>

                    <div className="col-xl-3 col-md-6">
                        <DashboardCard
                            label="Today MC"
                            tone="amber"
                            value={
                                <>
                                    <CountUp end={attendanceRate.total_mc || 0} separator="," />
                                    <span>
                                        ({Number(attendanceRate.mc_percentage || 0).toFixed(0)}%)
                                    </span>
                                </>
                            }
                            description="Students marked as MC"
                        />
                    </div>

                    <div className="col-xl-3 col-md-6">
                        <DashboardCard
                            label="Monthly Average"
                            tone="green"
                            value={
                                <>
                                    <CountUp
                                        end={monthlyData.monthly_average_attendance_rate || 0}
                                        decimals={2}
                                    />
                                    <small>%</small>
                                </>
                            }
                            description="Average attendance rate"
                        />
                    </div>

                    <div className="col-xl-3 col-md-6">
                        <DashboardCard
                            label="Registered Students"
                            tone="blue"
                            value={<CountUp end={state.totalStudent || 0} separator="," />}
                            description={
                                <div className="mysp-card-tags">
                                    <span>Face not recorded: {unrecorded}</span>
                                    <span>
                                        Parents connected: {claimParents}
                                        {" "}
                                        ({state.totalStudent > 0
                                            ? ((claimParents / state.totalStudent) * 100).toFixed(1)
                                            : "0.0"}%)
                                    </span>
                                </div>
                            }
                        />
                    </div>
                </div>

                {/* MOOD + FORM CHART */}
                <div className="row g-4 mt-1">
                    <div className="col-xl-4">
                        <Panel
                            title="School Mood"
                            subtitle="Emotion signal from attendance scans"
                            actions={
                                <div className="d-flex gap-2">
                                    <input
                                        type="month"
                                        className="form-control form-control-sm mysp-control"
                                        value={selectedMonth}
                                        onChange={(e) => setSelectedMonth(e.target.value)}
                                    />
                                    <select
                                        className="form-select form-select-sm mysp-control"
                                        value={moodPeriod}
                                        onChange={(e) => setMoodPeriod(e.target.value)}
                                    >
                                        <option value="weekly">Weekly</option>
                                        <option value="monthly">Monthly</option>
                                    </select>
                                </div>
                            }
                        >
                            {loadingMood ? (
                                <Skeleton height={230} borderRadius={20} />
                            ) : schoolMood ? (
                                <div className="mysp-mood-card">
                                    <div className="mysp-mood-score">
                                        <span>{Number(schoolMood.emotion_average.happy || 0).toFixed(1)}%</span>
                                        <small>Happy signal</small>
                                    </div>

                                    <div className="mysp-mood-bars">
                                        <MoodBar
                                            label="Happy"
                                            value={Number(schoolMood.emotion_average.happy || 0)}
                                            tone="green"
                                        />
                                        <MoodBar
                                            label="Neutral / Sad"
                                            value={
                                                Number(schoolMood.emotion_average.neutral || 0) +
                                                Number(schoolMood.emotion_average.sad || 0)
                                            }
                                            tone="amber"
                                        />
                                        <MoodBar
                                            label="Others"
                                            value={
                                                Number(schoolMood.emotion_average.surprise || 0) +
                                                Number(schoolMood.emotion_average.disgust || 0) +
                                                Number(schoolMood.emotion_average.anger || 0) +
                                                Number(schoolMood.emotion_average.fear || 0)
                                            }
                                            tone="red"
                                        />
                                    </div>
                                </div>
                            ) : (
                                <EmptyState title="No mood data available" />
                            )}
                        </Panel>
                    </div>

                    <div className="col-xl-8">
                        <Panel
                            title="Forms Monthly Attendance"
                            subtitle="Average attendance by form"
                        >
                            {loadingTrendByForm || trendByForm === null ? (
                                <Skeleton height={360} borderRadius={20} />
                            ) : Array.isArray(trendByForm) && trendByForm.length > 0 ? (
                                <ResponsiveContainer width="100%" height={isMobile ? trendByForm.length * 58 : 360}>
                                    <BarChart
                                        data={trendByForm}
                                        layout={isMobile ? "vertical" : "horizontal"}
                                        margin={{ top: 24, right: 24, left: isMobile ? 20 : 0, bottom: 10 }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" />

                                        {isMobile ? (
                                            <>
                                                <XAxis
                                                    type="number"
                                                    tick={{ fontSize: 12, fill: "#64748b" }}
                                                    tickFormatter={(v) => `${v}%`}
                                                    axisLine={false}
                                                    tickLine={false}
                                                />
                                                <YAxis
                                                    type="category"
                                                    dataKey="form"
                                                    tick={{ fontSize: 12, fill: "#0f172a", fontWeight: 700 }}
                                                    width={80}
                                                    axisLine={false}
                                                    tickLine={false}
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <XAxis
                                                    dataKey="form"
                                                    tick={{ fontSize: 13, fill: "#0f172a", fontWeight: 700 }}
                                                    axisLine={false}
                                                    tickLine={false}
                                                />
                                                <YAxis
                                                    tick={{ fontSize: 12, fill: "#64748b" }}
                                                    tickFormatter={(v) => `${v}%`}
                                                    axisLine={false}
                                                    tickLine={false}
                                                />
                                            </>
                                        )}

                                        <Tooltip
                                            formatter={(value) => [`${Number(value).toFixed(1)}%`, "Monthly Attendance"]}
                                            contentStyle={{
                                                border: "0",
                                                borderRadius: "16px",
                                                boxShadow: "0 18px 45px rgba(15,23,42,0.16)",
                                            }}
                                        />

                                        <Bar
                                            dataKey="monthly_attendance_rate"
                                            name="Monthly Attendance"
                                            radius={isMobile ? [0, 12, 12, 0] : [14, 14, 0, 0]}
                                            barSize={isMobile ? 24 : 44}
                                        >
                                            {trendByForm.map((entry, index) => (
                                                <Cell
                                                    key={`cell-${index}`}
                                                    fill={formColorMap[index % formColorMap.length]}
                                                />
                                            ))}
                                            <LabelList
                                                dataKey="monthly_attendance_rate"
                                                position={isMobile ? "right" : "top"}
                                                formatter={(v) => `${Number(v).toFixed(1)}%`}
                                                style={{
                                                    fill: "#0f172a",
                                                    fontWeight: 800,
                                                    fontSize: "12px",
                                                }}
                                            />
                                        </Bar>
                                    </BarChart>
                                </ResponsiveContainer>
                            ) : (
                                <EmptyState title="No form attendance data available" />
                            )}
                        </Panel>
                    </div>
                </div>

                {/* ATTENDANCE MATRIX */}
                {loadingClassSummary ? (
                    <div className="mt-4">
                        <Panel title="Attendance Matrix" subtitle="Loading class attendance summary">
                            <Skeleton height={360} borderRadius={20} />
                        </Panel>
                    </div>
                ) : classSummary && (() => {
                    const activeLabels = (classViewMode === "month" ? (classSummary.days || []) : (classSummary.weeks || []))
                        .map((label, index) => {
                            const hasData = classSummary.classes.some((c) => {
                                const val = classViewMode === "month" ? c.days[index] : c.weeks[index];
                                const percent = typeof val === "number" ? val : (val?.percent ?? 0);
                                return percent > 0;
                            });
                            return { label, index, hasData };
                        })
                        .filter((item) => item.hasData);

                    return (
                        <div
                            className={fullScreen ? "mysp-fullscreen" : "mt-4"}
                        >
                            <Panel
                                title="Attendance Matrix"
                                subtitle="Class attendance by active day or week"
                                actions={
                                    <div className="mysp-panel-actions">
                                        <input
                                            type="month"
                                            className="form-control form-control-sm mysp-control"
                                            value={selectedMonth}
                                            onChange={(e) => setSelectedMonth(e.target.value)}
                                        />

                                        <div className="mysp-segment">
                                            <button
                                                className={classViewMode === "month" ? "active" : ""}
                                                onClick={() => setClassViewMode("month")}
                                            >
                                                Day
                                            </button>
                                            <button
                                                className={classViewMode === "week_by_month" ? "active" : ""}
                                                onClick={() => setClassViewMode("week_by_month")}
                                            >
                                                Week
                                            </button>
                                        </div>

                                        <button
                                            className={`mysp-action-btn ${showHeatmap ? "danger" : ""}`}
                                            onClick={() => setShowHeatmap(!showHeatmap)}
                                        >
                                            {showHeatmap ? "Heatmap On" : "Plain View"}
                                        </button>

                                        <button
                                            className="mysp-action-btn dark"
                                            onClick={() => {
                                                setFullScreen(!fullScreen);
                                                setZoom(1);
                                            }}
                                        >
                                            {fullScreen ? "Close" : "Expand"}
                                        </button>
                                    </div>
                                }
                            >
                                <div className="mysp-table-toolbar">
                                    <div>
                                        <strong>{classSummary.classes?.length || 0}</strong>
                                        <span> class groups</span>
                                    </div>

                                    <div className="mysp-zoom">
                                        <button onClick={() => setZoom(Math.max(zoom - 0.1, 0.6))}>−</button>
                                        <span>{Math.round(zoom * 100)}%</span>
                                        <button onClick={() => setZoom(Math.min(zoom + 0.1, 1.4))}>+</button>
                                    </div>
                                </div>

                                <div className="mysp-matrix-scroll">
                                    <table
                                        className="mysp-matrix-table"
                                        style={{ fontSize: `${zoom}rem` }}
                                    >
                                        <thead>
                                            <tr>
                                                <th className="sticky-left">Class Group</th>
                                                {activeLabels.map(({ label }, i) => (
                                                    <th key={i}>{label}</th>
                                                ))}
                                                <th className="overall-head">Overall</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {classSummary.classes
                                                .filter((c) => c.average_percent > 0)
                                                .sort((a, b) => a.class_name.localeCompare(b.class_name, undefined, { numeric: true }))
                                                .map((c, i) => (
                                                    <tr key={i}>
                                                        <td className="sticky-left class-cell">
                                                            <Link to={`/class-details/${c.class_id}`}>
                                                                {c.class_name}
                                                            </Link>
                                                        </td>

                                                        {activeLabels.map(({ index }) => {
                                                            const val = classViewMode === "month" ? c.days[index] : c.weeks[index];
                                                            const percent = typeof val === "number" ? val : (val?.percent ?? 0);
                                                            const cellBg = showHeatmap && percent > 0 ? getHeatmapColor(percent) : "transparent";

                                                            return (
                                                                <td
                                                                    key={index}
                                                                    style={{ backgroundColor: cellBg }}
                                                                >
                                                                    <strong>
                                                                        {typeof val === "object"
                                                                            ? `${val.attended}/${val.total_students}`
                                                                            : `${percent.toFixed(0)}%`}
                                                                    </strong>

                                                                    {typeof val === "object" && (
                                                                        <small>{percent.toFixed(0)}%</small>
                                                                    )}
                                                                </td>
                                                            );
                                                        })}

                                                        <td
                                                            className="overall-cell"
                                                            style={{
                                                                backgroundColor: showHeatmap
                                                                    ? getHeatmapColor(c.average_percent)
                                                                    : "#f8fafc",
                                                            }}
                                                        >
                                                            {c.average_percent.toFixed(1)}%
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Panel>
                        </div>
                    );
                })()}
                {/* CUSTOM ATTENDANCE MATRIX */}
                <div className="mt-4">
                    <Panel
                        title="Custom Attendance Monthly Matrix"
                        subtitle="Custom attendance by class and date"
                        actions={
                            <div className="mysp-panel-actions">
                                <input
                                    type="month"
                                    className="form-control form-control-sm mysp-control"
                                    value={selectedMonth}
                                    onChange={(e) => setSelectedMonth(e.target.value)}
                                />

                                <button
                                    className={`mysp-action-btn ${showCustomHeatmap ? "danger" : ""}`}
                                    onClick={() => setShowCustomHeatmap(!showCustomHeatmap)}
                                >
                                    {showCustomHeatmap ? "Heatmap On" : "Plain View"}
                                </button>
                                <div className="mysp-segment">
                                    <button
                                        className={customMatrixViewMode === "slot" ? "active" : ""}
                                        onClick={() => setCustomMatrixViewMode("slot")}
                                    >
                                        Event
                                    </button>

                                    <button
                                        className={customMatrixViewMode === "date" ? "active" : ""}
                                        onClick={() => setCustomMatrixViewMode("date")}
                                    >
                                        Date
                                    </button>
                                </div>
                            </div>
                        }
                    >
                        {loadingCustomMonthlyMatrix ? (
                            <Skeleton height={360} borderRadius={20} />
                        ) : customMonthlyMatrix?.matrix?.length > 0 &&
                            customMonthlyMatrix?.classes?.length > 0 ? (
                            <>
                                <div className="mysp-matrix-scroll">
                                    <table
                                        className="mysp-matrix-table"
                                        style={{ fontSize: `${zoom}rem` }}
                                    >
                                        <thead>
                                            <tr>
                                                <th className="sticky-left class-cell class-name-col">Class</th>

                                                {customMatrixViewMode === "slot"
                                                    ? (customMonthlyMatrix.slots || []).map((slot) => (
                                                        <th key={slot.typeId || slot.type_id || slot.eventName || slot.event_name}>
                                                            <div className="matrix-slot-head">
                                                                <strong>{slot.eventName || slot.event_name || "Event"}</strong>
                                                                <span>{slot.eventDate || slot.event_date || ""}</span>
                                                            </div>
                                                        </th>
                                                    ))
                                                    : (customMonthlyMatrix.dates || []).map((date) => (
                                                        <th key={date}>
                                                            {new Date(date).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                            })}
                                                        </th>
                                                    ))}

                                                <th className="overall-head">Total</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {(customMonthlyMatrix.matrix || []).map((row) => {
                                                const className = row.className || row.class_name || 'Unknown';
                                                const classId = row.classId || row.class_id || className;

                                                const cells =
                                                    customMatrixViewMode === "slot"
                                                        ? (row.slots || [])
                                                        : (row.dates || []);

                                                const totalStudentsInClass =
                                                    row.totalStudentsInClass ??
                                                    row.total_students_in_class ??
                                                    0;

                                                const totalUnique =
                                                    row.totalUniqueStudents ??
                                                    row.total_unique_students ??
                                                    0;

                                                const possible =
                                                    customMatrixViewMode === "slot"
                                                        ? (row.monthlyPossibleStudentSlotCount ??
                                                            row.monthly_possible_student_slot_count ??
                                                            totalStudentsInClass * cells.length)
                                                        : (row.monthlyPossibleStudentDateCount ??
                                                            row.monthly_possible_student_date_count ??
                                                            totalStudentsInClass * cells.length);

                                                const rowPercent =
                                                    row.attendancePercent ??
                                                    row.attendance_percent ??
                                                    (possible > 0 ? (Number(totalUnique || 0) / Number(possible || 1)) * 100 : 0);

                                                return (
                                                    <tr key={classId}>
                                                        <td className="sticky-left class-cell class-name-col">
                                                            <strong>{className}</strong>
                                                        </td>

                                                        {cells.map((cell, index) => {
                                                            const uniqueStudents =
                                                                cell?.uniqueStudents ??
                                                                cell?.unique_students ??
                                                                0;

                                                            const totalStudents =
                                                                cell?.totalStudentsInClass ??
                                                                cell?.total_students_in_class ??
                                                                totalStudentsInClass;

                                                            const percent =
                                                                cell?.attendancePercent ??
                                                                cell?.attendance_percent ??
                                                                0;

                                                            const key =
                                                                customMatrixViewMode === "slot"
                                                                    ? `${classId}-${cell?.typeId || cell?.type_id || index}`
                                                                    : `${classId}-${cell?.date || index}`;

                                                            const cellBg =
                                                                showCustomHeatmap && Number(percent) > 0
                                                                    ? getCustomMatrixCellColor(percent)
                                                                    : 'transparent';

                                                            return (
                                                                <td key={key} style={{ backgroundColor: cellBg }}>
                                                                    <div className="matrix-cell-compact">
                                                                        <strong>{uniqueStudents}/{totalStudents}</strong>
                                                                        <span>{Number(percent || 0).toFixed(0)}%</span>
                                                                    </div>
                                                                </td>
                                                            );
                                                        })}

                                                        <td
                                                            className="overall-cell"
                                                            style={{
                                                                backgroundColor: showCustomHeatmap
                                                                    ? getCustomMatrixCellColor(rowPercent)
                                                                    : '#f8fafc',
                                                            }}
                                                        >
                                                            <div className="matrix-cell-compact">
                                                                <strong>{totalUnique}/{possible}</strong>
                                                                <span>{Number(rowPercent || 0).toFixed(0)}%</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        ) : (
                            <EmptyState title="No custom attendance data available for this month" />
                        )}
                    </Panel>
                </div>
                {/* DAILY TREND */}
                {monthlyData?.daily_summary && (
                    <div className="mt-4">
                        <Panel
                            title="Daily Attendance Trend"
                            subtitle="Monthly attendance movement across active school days"
                            actions={
                                <input
                                    type="month"
                                    className="form-control form-control-sm mysp-control"
                                    value={selectedMonth}
                                    onChange={(e) => setSelectedMonth(e.target.value)}
                                />
                            }
                        >
                            {loadingMonthly ? (
                                <Skeleton height={320} borderRadius={20} />
                            ) : (
                                <ResponsiveContainer width="100%" height={320}>
                                    <LineChart
                                        data={monthlyData.daily_summary}
                                        margin={{ top: 16, right: 20, left: -16, bottom: 0 }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" />
                                        <XAxis
                                            dataKey="date"
                                            axisLine={false}
                                            tickLine={false}
                                            tick={{ fontSize: 12, fill: "#64748b" }}
                                            dy={10}
                                        />
                                        <YAxis
                                            axisLine={false}
                                            tickLine={false}
                                            tick={{ fontSize: 12, fill: "#64748b" }}
                                            tickFormatter={(v) => `${v}%`}
                                        />
                                        <Tooltip
                                            formatter={(value) => [`${Number(value).toFixed(2)}%`, "Attendance Rate"]}
                                            contentStyle={{
                                                border: "0",
                                                borderRadius: "16px",
                                                boxShadow: "0 18px 45px rgba(15,23,42,0.16)",
                                            }}
                                        />
                                        <Line
                                            type="monotone"
                                            dataKey="attendance_rate"
                                            stroke="#ef4444"
                                            strokeWidth={4}
                                            dot={{ r: 3, fill: "#ef4444", strokeWidth: 2, stroke: "#fff" }}
                                            activeDot={{ r: 7 }}
                                        />
                                    </LineChart>
                                </ResponsiveContainer>
                            )}
                        </Panel>
                    </div>
                )}

                {/* FORM BREAKDOWN */}
                {attendanceByForm.length > 0 && (
                    <div className="mt-4">
                        <Panel
                            title="Attendance Breakdown by Form"
                            subtitle="Present students against registered students"
                        >
                            <div className="row g-4">
                                {attendanceByForm.map((item, index) => (
                                    <div className="col-12 col-md-6 col-xl-4" key={index}>
                                        <div className="mysp-form-card">
                                            <div className="mysp-form-head">
                                                <span
                                                    style={{ backgroundColor: getFormColor(index) }}
                                                />
                                                <strong>{item.form}</strong>
                                            </div>

                                            <div className="mysp-form-body">
                                                <div className="mysp-progress-ring">
                                                    <CircularProgressbar
                                                        value={item.attendance_percentage}
                                                        text={`${item.attendance_percentage.toFixed(1)}%`}
                                                        styles={buildStyles({
                                                            textColor: "#0f172a",
                                                            pathColor: getFormColor(index),
                                                            trailColor: "#e5e7eb",
                                                            textSize: "18px",
                                                            strokeLinecap: "round",
                                                        })}
                                                    />
                                                </div>

                                                <div>
                                                    <h4>{item.total_present} / {item.total_students}</h4>
                                                    <p>Students present</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Panel>
                    </div>
                )}

                {/* LOCATION CLUSTERS */}
                <div className="mt-4">
                    <Panel
                        title="Location Clusters"
                        subtitle="Student check-in concentration by gate or location"
                        actions={
                            <div className="d-flex align-items-center gap-2">
                                <span className="mysp-total-pill">
                                    Total: {totalStudentsLocation}
                                </span>
                                <input
                                    type="date"
                                    className="form-control form-control-sm mysp-control"
                                    value={selectedClusterDate}
                                    onChange={(e) => setSelectedClusterDate(e.target.value)}
                                />
                            </div>
                        }
                    >
                        {loadingClusters ? (
                            <Skeleton height={460} borderRadius={20} />
                        ) : locationClusters.length === 0 ? (
                            <EmptyState title="No location cluster data available" />
                        ) : (
                            <div className="mysp-map-wrap">
                                <MapContainer
                                    center={[3.139, 101.6869]}
                                    zoom={16}
                                    scrollWheelZoom={true}
                                    style={{ height: "520px", width: "100%" }}
                                >
                                    <TileLayer
                                        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://www.carto.com/">CARTO</a>'
                                        subdomains={["a", "b", "c", "d"]}
                                    />

                                    {locationClusters.map((cluster, idx) => (
                                        <Marker
                                            key={idx}
                                            position={[cluster.latitude, cluster.longitude]}
                                            icon={glowingIcon}
                                        >
                                            <Popup>
                                                <b>Gate #{cluster.cluster_id}</b>
                                                <br />
                                                Students: {cluster.count}
                                                <br />
                                            </Popup>
                                        </Marker>
                                    ))}

                                    <FitBounds clusters={locationClusters} />
                                </MapContainer>
                            </div>
                        )}
                    </Panel>
                </div>

                {/* CLASS TABLE */}
                <div className="mt-4">
                    <Panel
                        title="Attendance Breakdown by Class"
                        subtitle="Class-level attendance summary"
                    >
                        <DataTable
                            columns={columns}
                            data={classes}
                            striped={false}
                            center={true}
                            persistTableHead
                            customStyles={myspDataTableStyles}
                        />
                    </Panel>
                </div>

                {/* MONTHLY CLASS REPORT */}
                <div className="mt-4">
                    <Panel
                        title="Monthly Class Attendance Report"
                        subtitle="Student-level attendance and warning status"
                        actions={
                            <div className="mysp-panel-actions">
                                <select
                                    className="form-select form-select-sm mysp-control"
                                    value={selectedClassId}
                                    onChange={(e) => setSelectedClassId(e.target.value)}
                                >
                                    <option value="all">All Classes</option>
                                    {classes.map((c) => (
                                        <option key={c.class_id ?? c.id} value={c.class_id ?? c.id}>
                                            {c.class_name}
                                        </option>
                                    ))}
                                </select>

                                <input
                                    type="month"
                                    className="form-control form-control-sm mysp-control"
                                    value={selectedMonth}
                                    onChange={(e) => setSelectedMonth(e.target.value)}
                                />
                            </div>
                        }
                    >
                        {Array.isArray(classMonthlyData?.students) ? (
                            <>
                                <div className="mysp-report-head">
                                    <div>
                                        <strong>
                                            {selectedClassId !== "all"
                                                ? classes.find((c) => String(c.class_id ?? c.id) === String(selectedClassId))?.class_name || "Selected Class"
                                                : "All Classes"}
                                        </strong>
                                        <span>{selectedMonth}</span>
                                    </div>

                                    <span className="mysp-total-pill red">
                                        Class Avg: {Number(classMonthlyData.classAverageRate ?? 0).toFixed(2)}%
                                    </span>
                                </div>

                                {classMonthlyData.students.length > 0 ? (
                                    <div className="mysp-table-responsive">
                                        <table className="mysp-clean-table">
                                            <thead>
                                                <tr>
                                                    <th>Student</th>
                                                    <th className="text-center">Present</th>
                                                    <th className="text-center">Total Days</th>
                                                    <th className="text-center">Absent</th>
                                                    <th className="text-center">Attendance</th>
                                                    <th className="text-center">Amaran Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {classMonthlyData.students.map((s) => (
                                                    <tr key={s.student_id}>
                                                        <td>
                                                            <div className="mysp-student-cell">
                                                                {s.profile_pic ? (
                                                                    <img src={s.profile_pic} alt="" />
                                                                ) : (
                                                                    <div className="mysp-avatar">
                                                                        {(s.student_name || s.student_id || "S").charAt(0)}
                                                                    </div>
                                                                )}

                                                                <div>
                                                                    <strong>{s.student_name || s.student_id}</strong>
                                                                    <span>{s.student_id}</span>
                                                                </div>
                                                            </div>
                                                        </td>

                                                        <td className="text-center fw-bold">{s.present_days ?? 0}</td>
                                                        <td className="text-center">{s.total_days ?? 0}</td>
                                                        <td className="text-center text-danger fw-bold">
                                                            {s.absent_days ?? ((s.total_days ?? 0) - (s.present_days ?? 0))}
                                                        </td>
                                                        <td className="text-center fw-bold">
                                                            {Number(s.attendance_rate ?? 0).toFixed(2)}%
                                                        </td>
                                                        <td className="text-center">
                                                            <span
                                                                className={`mysp-status-badge ${(s.amaran_status || "").includes("Buang") ||
                                                                    (s.amaran_status || "").includes("Amaran 3")
                                                                    ? "danger"
                                                                    : (s.amaran_status || "").includes("Amaran 2") ||
                                                                        (s.amaran_status || "").includes("Amaran 1")
                                                                        ? "warning"
                                                                        : "success"
                                                                    }`}
                                                            >
                                                                {s.amaran_status || "Good Standing"}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <EmptyState title="No student data available for this selection" />
                                )}

                                <div className="mysp-note">
                                    <strong>Amaran thresholds:</strong> 3+ days = Amaran 1, 10+ days = Amaran 2,
                                    17+ days = Amaran 3, 31+ days = Amaran 4 / Buang Sekolah.
                                </div>
                            </>
                        ) : (
                            <EmptyState title="Select a class to view monthly attendance" />
                        )}
                    </Panel>
                </div>
            </div>
        </Fragment>
    );
}

export default Homepage;

const DashboardCard = ({ label, value, description, tone = "red" }) => {
    return (
        <div className={`mysp-stat-card ${tone}`}>
            <div className="mysp-stat-label">
                <span />
                {label}
            </div>

            <div className="mysp-stat-value">
                {value}
            </div>

            <div className="mysp-stat-description">
                {description}
            </div>
        </div>
    );
};

const Panel = ({ title, subtitle, actions, children }) => {
    return (
        <div className="mysp-panel">
            <div className="mysp-panel-header">
                <div>
                    <h3>{title}</h3>
                    {subtitle && <p>{subtitle}</p>}
                </div>

                {actions && (
                    <div className="mysp-panel-action-wrap">
                        {actions}
                    </div>
                )}
            </div>

            <div className="mysp-panel-body">
                {children}
            </div>
        </div>
    );
};

const MoodBar = ({ label, value, tone }) => {
    const safeValue = Math.min(Math.max(Number(value || 0), 0), 100);

    return (
        <div className="mysp-mood-bar">
            <div className="mysp-mood-bar-head">
                <span>{label}</span>
                <strong>{safeValue.toFixed(2)}%</strong>
            </div>

            <div className="mysp-mood-track">
                <div
                    className={tone}
                    style={{ width: `${safeValue}%` }}
                />
            </div>
        </div>
    );
};

const EmptyState = ({ title }) => {
    return (
        <div className="mysp-empty">
            <div />
            <strong>{title}</strong>
            <span>There is no matching data for the selected filter.</span>
        </div>
    );
};

const myspDataTableStyles = {
    table: {
        style: {
            borderRadius: "20px",
            overflow: "hidden",
        },
    },
    headRow: {
        style: {
            backgroundColor: "#f8fafc",
            borderBottomColor: "#e5e7eb",
            minHeight: "56px",
        },
    },
    headCells: {
        style: {
            color: "#475569",
            fontSize: "12px",
            fontWeight: 900,
            textTransform: "uppercase",
            letterSpacing: "0.08em",
        },
    },
    rows: {
        style: {
            minHeight: "62px",
            borderBottomColor: "#eef2f7",
            fontSize: "14px",
            color: "#0f172a",
        },
        highlightOnHoverStyle: {
            backgroundColor: "#fff7f7",
        },
    },
};